module.exports = __webpack_public_path__ + "img/3.d40c05db.png";